<div class="row justify-content-center">
  <div [ngClass]="{'col-12': this.isInPopup, 'col-xl-4 col-lg-5 col-md-6 col-sm-8': !this.isInPopup}">
    <h1 class="h3 mb-3 font-weight-normal" [ngClass]="{'text-center': this.isInPopup}">
      <span *ngIf="!this.isInPopup">Inicio de sesión</span>
      <span *ngIf="this.isInPopup">Requiere permisos</span>
    </h1>
    <div class="form-group">
      <label for="email">Correo electrónico</label>
      <input id="email" type="email" class="form-control" placeholder="" name="email" [(ngModel)]="this.formData.email">
    </div>
    <div class="form-group">
      <label for="password">Contraseña</label>
      <input id="password" type="password" class="form-control" name="password" [(ngModel)]="this.formData.password">
    </div>
    <button class="use-app-colors btn btn-lg btn-primary btn-block mt-3" type="button" (click)="this.login()">
      <span *ngIf="!this.processing">Ingresar</span>
      <div *ngIf="this.processing" class="spinner-border"></div>
    </button>
    <div class="mt-3">
      <a (click)="this.forgotPassword()" class="app-link">¿Olvidó su contraseña?</a>
    </div>
    <div class="mt-3">
      <a (click)="this.goToSignUp()" class="app-link">Registrarse</a>
    </div>
    <hr>
    <div>
      <!--<div class="social-media-login-button-container">
        <span id="social-media-login-button-facebook" class="social-media-login-button" (click)="this.externalLogin('Facebook')">
          <span class="social-media-login-button-icon">
            <fa-icon [icon]="faFacebookF"></fa-icon>
          </span>
          <span class="social-media-login-button-text">
            Iniciar sesión con Facebook
          </span>
        </span>
      </div>-->
      <div class="social-media-login-button-container">
        <span id="social-media-login-button-google" class="social-media-login-button" (click)="this.externalLogin('Google')">
          <span class="social-media-login-button-icon">
            <fa-icon [icon]="faGoogle"></fa-icon>
          </span>
          <span class="social-media-login-button-text">
            Iniciar sesión con Google
          </span>
        </span>
      </div>
      <!--<div class="social-media-login-button-container">
        <span id="social-media-login-button-twitter" class="social-media-login-button" (click)="this.externalLogin('Twitter')">
          <span class="social-media-login-button-icon">
            <fa-icon [icon]="faTwitter"></fa-icon>
          </span>
          <span class="social-media-login-button-text">
            Iniciar sesión con Twitter
          </span>
        </span>
      </div>-->
    </div>
    <div *ngIf="this.formData.error" [innerHTML]="this.formData.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
    <div *ngIf="this.formData.message" [innerHTML]="this.formData.message" class="messages-container mt-3 alert alert-success" role="alert"></div>
  </div>
</div>
